import { useUser } from "@hooks/useUser";
import { ActorIcon } from "@components/history/components/ActorIcon";
import { ActorName } from "@components/history/components/ActorName";
import {
    resolveActorChannelLabel,
    resolveActorDisplayName,
} from "@components/history/utils/actorUtils";
import { toPersonName } from "./components/organizationActorPeople";
import type { OrganizationActivityRow } from "./organizationActivityRow";
import { useOrganizationActivityPeopleById } from "./OrganizationActivityPeopleProvider";
import { useVisibleActivityChannel } from "./useVisibleActivityChannel";

interface OrganizationActivityActorProps {
    row: OrganizationActivityRow;
    nameClassName?: string;
}

/** Who made an org Activity change: their icon and name, resolving org members and client users. */
export const OrganizationActivityActor = ({
    row: { actorId, actorName, actorType, sourceType, changeTypes, channel },
    nameClassName,
}: OrganizationActivityActorProps) => {
    const currentUser = useUser();
    const peopleById = useOrganizationActivityPeopleById();
    const visibleChannel = useVisibleActivityChannel(channel);

    const person = actorId !== null ? peopleById.get(actorId) : undefined;
    const personName = person ? toPersonName(person) : undefined;
    const actorParams = {
        actorType,
        actorName,
        sourceType,
        changeTypes,
        currentUserId: currentUser?.id,
        actorId,
        memberName: personName,
    };

    return (
        <>
            <ActorIcon
                actorType={actorType}
                actorName={actorName}
                sourceType={sourceType}
                user={
                    person
                        ? {
                              preferredName: personName,
                              avatar: person.avatar,
                              iconColor: person.iconColor,
                              email: person.email,
                          }
                        : undefined
                }
                changeTypes={changeTypes}
            />
            <ActorName
                name={resolveActorDisplayName(actorParams)}
                channelLabel={resolveActorChannelLabel({
                    ...actorParams,
                    channel: visibleChannel,
                })}
                className={nameClassName}
            />
        </>
    );
};
